module.exports = __webpack_public_path__ + "img/logo.43c16594.png";